import { on, select, scrollTop, getScrollTop } from 'modules/dom'
import { getProp, setProp } from 'modules/utils'

const wrapper = select('.js-wrapper')

export default function(el) {
  const selectAnchorEl = select('.js-select-anchor', el)
  const anchorOptions = getProp('options', selectAnchorEl)
  const selectCurrentAnchorEl = select('.js-current-anchor', el)

  const getCurrentOption = function() {
    let selectedIndex = getProp('selectedIndex', selectAnchorEl)
    return anchorOptions[selectedIndex]
  }
  const getCurrentText = function() {
    let currentOption = getCurrentOption()
    return getProp('text', currentOption)
  }
  const getCurrentValue = function() {
    let currentOption = getCurrentOption()
    return getProp('value', currentOption)
  }
  const setCurrentText = function() {
    let currentText = getCurrentText()
    setProp('innerHTML', currentText, selectCurrentAnchorEl)
  }
  const scrollToAnchor = function(anchor) {
    if (anchor) {
      const anchorEl = select(`${anchor}`)
      if (anchorEl && wrapper) {
        let offset = anchorEl.getBoundingClientRect().top + getScrollTop(wrapper)
        scrollTop(offset, undefined, wrapper)
      }
    }
  }
  on('change', () => {
    scrollToAnchor(getCurrentValue())
  }, selectAnchorEl)
  setCurrentText()
}
